import React from 'react';
import { Crisp } from "crisp-sdk-web"
import { MessageCircle, ArrowRight } from 'lucide-react';

const HavingTroubleCard = () => {
    return (
        <div
            className="rounded-4 p-4 d-flex align-items-center justify-content-between gap-4 flex-wrap"
            style={{
                background: 'linear-gradient(135deg, var(--bs-primary) 0%, var(--bs-secondary) 100%)',
                boxShadow: '0 8px 32px rgba(var(--bs-primary-rgb), 0.25)',
            }}
        >
            <div className="d-flex align-items-center gap-3">
                <div
                    className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{ width: 44, height: 44, background: 'rgba(255,255,255,0.2)' }}
                >
                    <MessageCircle size={22} color="white" strokeWidth={1.75} />
                </div>
                <div>
                    <p className="fw-bold text-white mb-0" style={{ fontSize: '1rem' }}>Having trouble using Listen2It?</p>
                    <p className="mb-0 text-white" style={{ opacity: 0.85, fontSize: '0.82rem' }}>Our team is here to help — reach out anytime.</p>
                </div>
            </div>
            <button
                type="button"
                className="btn fw-semibold flex-shrink-0 d-flex align-items-center gap-2"
                onClick={() => Crisp.chat.open()}
                style={{
                    background: 'white',
                    color: 'var(--bs-primary)',
                    borderRadius: 50,
                    padding: '9px 22px',
                    fontSize: 13,
                    border: 'none',
                    whiteSpace: 'nowrap',
                }}
            >
                Contact Us <ArrowRight size={15} />
            </button>
        </div>
    );
};

export default HavingTroubleCard;

